<div class="order-summary-wrapper">
<div class="page-title-section row m-0 pt-5 pb-4 flex-column">
  <div class="main-title main-theme-color d-flex justify-content-center text-center text-uppercase">
    {{ "orderSummary" | translate }}
  </div>
  <div
    class="sub-title secondary-theme-color position-relative  justify-content-center text-center text-uppercase flex-wrap order-summary-sub-title">
    {{ "checkYourActivityBeforeBooking" | translate }}
    @if (!isEdit) {
      <div class="d-flex clear-cart-decoration justify-content-center">
        <a class="text-uppercase" (click)="clearCart()">{{
          "clearCart" | translate
        }}</a>
      </div>
    }
  </div>
</div>
@if (showCartLockWarning) {
  <div class="cart__warningmessage text-center pt-3">
    {{ "cartLockWarningMessage" | translate }}
  </div>
}
@if (infoMessage) {
  <div class="cart__warningmessage text-center pt-3">
    {{ infoMessage }}
  </div>
}
<div class="d-flex flex-wrap justify-content-center">
  <div class="col-md-12 m-top"></div>

  @if (overallBookings?.length > 0) {
    <div class="col-xl-4 col-lg-6 col-12 mt-3 mt-xl-0" [hidden]="activityService?.DisableCustomTermsAndConditions && isValidateTerms">
      <!-- Add multi to show multiple expansion parallely or only one expansion to be open at a time -->
      <mat-accordion multi="true" class="activity-accordian-accordian">
        <!-- Remove disabled when having more than 1 slot bookings -->
        @for (slot of overallBookings; track slot; let actIndex = $index) {
          <mat-expansion-panel hideToggle [expanded]="actIndex == 0" class="mb-3 activity-accordian-panel"
        [disabled]="
          slot.bookingTypeVariants?.length === 0 &&
          slot.coverTypeVariants?.length === 0 &&
          !slot.TotalAmount &&
          !slot.TotalAddonAmount &&
          !slot.RateplanAmountinfo
        ">
            <mat-expansion-panel-header class="activity-panel-header">
              <div class="flex-column w-100">
                <div class="w-100 order-summary-short-detail-section p-3 mx-2 d-flex flex-row justify-content-between"
              [ngStyle]="{
              'background-color': !slot.isAvailable ? 'rgba(255,0,0,0.1)' : ''
            }" [class.auth-card-booking]="
              slot.WidgetPrePaymentMode === AuthOnlyPaymentMode
            ">
                  <div
                    class="guest-count activity-description-bold d-flex flex-wrap justify-content-center align-items-center text-center">
                    <mat-icon>card_travel</mat-icon>
                    <div class="px-2 order-details-activity-name text-wrap text-center">
                      {{ slot.ActivityName }}
                    </div>
                  </div>
                  <div class="order-summary-spacer mx-2"></div>
                  <div
                    class="guest-count activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
                    <mat-icon>person</mat-icon>
                    <div class="px-2 text-center">{{ slot.Size }}</div>
                  </div>
                  <div class="order-summary-spacer mx-2"></div>
                  <div
                    class="activity-selected-date activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
                    <mat-icon>calendar_today</mat-icon>
                    <div class="px-2 text-center">
                      <ng-container>{{
                        (slot?.TimeRange?.Start
                        ? slot?.TimeRange?.Start
                        : slot.FormattedLocalTime
                        )
                        | date
                        : "dd MMM yyyy"
                      }}</ng-container>
                    </div>
                  </div>
                  <div class="order-summary-spacer mx-2"></div>
                  <div
                    class="activity-selected-time activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
                    <mat-icon>access_time</mat-icon>
                    <div class="px-2 d-flex align-items-center justify-content-center">
                      <span class="text-center">
                        <ng-container>{{
                          (slot?.TimeRange?.Start
                          ? slot?.TimeRange?.Start
                          : slot.FormattedLocalTime
                          ) | date : "hh:mm a"
                        }}</ng-container>
                      </span>
                    </div>
                  </div>
                  @if (!isEdit) {
                    <div
                      class="activity-location activity-description-bold d-flex flex-end justify-content-center align-items-center"
                      (click)="deleteCartItem(actIndex, $event)">
                      <mat-icon matTooltip="{{ 'Delete' | translate }}">
                        <mat-icon>delete</mat-icon>
                      </mat-icon>
                    </div>
                  }
                  @if (slot.WidgetPrePaymentMode === AuthOnlyPaymentMode) {
                    <div class="auth-card-icon">
                      <img src="assets/images/auth_card.svg" alt="agilysys-logo" />
                    </div>
                  }
                </div>
                @if (slot.NoShowFeeAmount) {
                  <div class="no-showfee-cell">
                    <span>
                      {{'noShowFee' | translate}}
                      <span class="icon-Info" [matTooltip]="'RestaurantCreditCardAssurance' | translate"></span>
                    </span>
                    <span>{{ operationCurrency
                    }} {{slot.NoShowFeeAmount | number : "1.2-2"}}</span>
                  </div>
                }
              </div>
            </mat-expansion-panel-header>
            <div class="price-splitup-section" [hidden]="slot?.Total == 0">
              <div class="p-0 col-12 price-splitup-table d-flex flex-column">
                <div class="py-1 price-table-header d-flex flex-row">
                  <div class="p-0 col-lg-6 col-5">
                    <div class="activity-description-bolder">
                      {{ _MESSAGES.Labels.description | translate }}
                    </div>
                  </div>
                  <div class="p-0 col-lg-2 col-2 d-flex justify-content-center">
                    <div class="activity-description-bolder text-right">
                      {{ _MESSAGES.Labels.quantity | translate }}
                    </div>
                  </div>
                  <div class="p-0 col-lg-2 col-2 d-flex justify-content-end">
                    <div class="activity-description-bolder text-right">
                      {{ _MESSAGES.Labels.grossPrice | translate }}
                    </div>
                  </div>
                  <div class="p-0 col-lg-2 col-3 d-flex justify-content-end">
                    <div class="activity-description-bolder text-right">
                      {{ _MESSAGES.Labels.totalPrice | translate }}
                    </div>
                  </div>
                </div>
                <div class="py-1 price-table-data-cell d-flex flex-row flex-wrap">
                  <div class="p-0 col-lg-10 col-10">
                    <div class="activity-description-bold text-wrap cursor" (click)="showDetailedView = !showDetailedView">
                      {{ slot.ActivityName }}
                      <!-- <i class="icon-Info" @if (slot.Type == 19) {></i> } -->
                      <span class="down-icon mb-1 ms-2 "
                      [ngClass]="{'expandedView': showDetailedView}"></span>
                    </div>
                  </div>
                  <div class="p-0 col-lg-2 col-2 d-flex justify-content-end">
                    <div class="activity-description-bold text-truncate">
                      {{ operationCurrency
                      }}{{
                      (slot.SubTotal ? slot.SubTotal : 0)
                      | currencyDecimalFormatter
                      }}
                    </div>
                    <!-- <mat-icon class="ps-3 ordered-activity-delete">delete</mat-icon> -->
                  </div>
                </div>
                @if (showDetailedView) {
                  <div>
                    @for (lineItem of slot.Items; track lineItem; let i = $index) {
                      <div class="py-1 price-table-data-cell d-flex flex-row flex-wrap"
                        >
                        <div class="p-0 col-lg-6 col-5">
                          <div class="activity-description-bold text-wrap ps-5" [ngClass]="{'activity-description-bold__highlight': lineItem.Type == PaymentItemType.Deposit || lineItem.Type == PaymentItemType.RefundableDeposit || lineItem.Type == PaymentItemType.NonRefundableDeposit }" >
                            {{ lineItem.Name }}
                            @if ((lineItem.Type == PaymentItemType.Deposit || lineItem.Type == PaymentItemType.RefundableDeposit || lineItem.Type == PaymentItemType.NonRefundableDeposit) && lineItem.Description) {
                              <i class="icon-Info" matTooltip="{{ lineItem.Description }}" matTooltipPosition="above"></i>
                            }
                            <!-- <span class="down-icon mb-1 ms-2 " @if (lineItem.VAT > 0) {
                          [ngClass]="{'expandedView': lineItem['TaxExpandedView']}"></span> -->
                        </div>
                      </div>
                      <div class="p-0 col-lg-2 col-2 d-flex justify-content-center">
                        <div class="activity-description-bold">
                          {{ lineItem | groupItemByType: slot : 'Count' }}
                        </div>
                      </div>
                      <div class="p-0 col-lg-2 col-2 d-flex justify-content-end">
                        <div class="activity-description-bold text-truncate">
                          {{ operationCurrency
                          }}
                          {{
                          (lineItem.PayableUnitPrice ? ( lineItem.PayableUnitPrice ) : 0) | currencyDecimalFormatter
                          }}
                        </div>
                      </div>
                      <div class="p-0 col-lg-2 col-3 d-flex justify-content-end">
                        <div class="activity-description-bold text-truncate">
                          {{ operationCurrency
                          }}{{
                          (lineItem.SubTotal ? ( lineItem | groupItemByType: slot : 'SubTotal' ) : 0)
                          | currencyDecimalFormatter
                          }}
                        </div>
                        <!-- <mat-icon class="ps-3 ordered-activity-delete">delete</mat-icon> -->
                      </div>
                    </div>
                  }
                  @if (slot && (slot.VAT > 0 || slot.Tax > 0) && ((showDetailedView && taxTypeForBooking) )) {
                    <span class="w-100 ps-5"
                      >
                      <ng-container class="py-1 price-table-data-cell d-flex flex-row"
                        *ngTemplateOutlet="vatInfo; context: { $implicit: slot }">
                      </ng-container>
                    </span>
                  }
                  <!-- Total tax and Service Charge Amount -->
                  @if (slot && slot.ServiceCharge > 0 ) {
                    <span>
              <ng-container class="py-1 price-table-data-cell d-flex flex-row" *ngTemplateOutlet="
                  serviceChargeInfo;
                  context: { $implicit: slot }
                ">
                      </ng-container>
                    </span>
                  }
                  @if (slot && (slot.VAT > 0 || slot.Tax > 0) && !taxTypeForBooking) {
                    <span class="w-100 ">
                      <ng-container class="py-1 price-table-data-cell d-flex flex-row"
                        *ngTemplateOutlet="vatInfo; context: { $implicit: slot }">
                      </ng-container>
                    </span>
                  }
                  @if (slot?.RatePlanTotal?.MinRateAdjustmentAmount > 0) {
                    <div class="py-1 price-table-data-cell d-flex flex-row"
                      >
                      <div class="p-0 col-lg-6 col-5">
                        <div class="activity-description-bold text-wrap">
                          {{ _MESSAGES.Labels.minRateAdjustment | translate }}
                        </div>
                      </div>
                      <div class="p-0 col-lg-2 col-2 d-flex justify-content-center">
                        <div class="activity-description-bold"></div>
                      </div>
                      <div class="p-0 col-lg-4 col-5 d-flex justify-content-end float-right">
                        <div class="activity-description-bold text-truncate">
                          {{ operationCurrency
                          }}{{
                          (slot?.RatePlanTotal?.MinRateAdjustmentAmount
                          ? slot?.RatePlanTotal?.MinRateAdjustmentAmount
                          : 0
                          ) | currencyDecimalFormatter
                          }}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
    <ng-template #vatInfo let-paymentData>
      <div class="d-flex flex-row justify-content-between cursor">
        <div class="p-0 col-9">
          <div class="activity-description-bold" (click)="
              paymentData['TaxExpandedView'] = !paymentData['TaxExpandedView']
            ">
            <span class="pe-2">{{
              taxTypeForBooking ? "VAT" : ("Tax" | translate)
            }}</span>
            <ng-container>
              <span class="down-icon mb-1 ms-2" [ngClass]="{ expandedView: paymentData['TaxExpandedView'] }"></span>
            </ng-container>
          </div>
        </div>
        <div class="p-0 col-3 d-flex justify-content-end">
          <div class="activity-description-bold">
            {{ operationCurrency }}
            {{
            taxTypeForBooking
            ? paymentData?.VAT
            : (paymentData?.Tax | currencyDecimalFormatter)
            }}
          </div>
        </div>
      </div>
      @if (paymentData?.TaxExpandedView && paymentData?.Taxes?.length) {
        @for (taxItem of paymentData?.Taxes; track taxItem) {
          <div class="d-flex flex-row justify-content-between p-0 ps-5 tax-list col-lg-12 col-md-12"
            >
            <div class="p-0 col-9">
              <div class="activity-description-bold">
                @if (taxItem.IsPercentage) {
                  <span>{{ taxItem.ChargeName }} &#64; {{ taxItem.ChargeValue }}%
                  </span>
                }
                @if (!taxItem.IsPercentage) {
                  <span>{{ taxItem.ChargeName }}
                  </span>
                }
              </div>
            </div>
            <div class="p-0 col-3 d-flex justify-content-end">
              <div class="activity-description-bold">
                {{ operationCurrency }}
                {{ taxItem.Amount | currencyDecimalFormatter }}
              </div>
            </div>
          </div>
        }
      }
    </ng-template>
    <ng-template #serviceChargeInfo let-paymentData>
      <div (click)="
          paymentData['serviceChargeExpandedView'] =
            !paymentData['serviceChargeExpandedView']
        " class="d-flex flex-row justify-content-between cursor">
        <div class="p-0 col-9">
          <div class="activity-description-bold">
            <span class="pe-2">{{"serviceCharges" | translate}}</span><span class="down-icon mb-1 ms-2" [ngClass]="{
                expandedView: paymentData['serviceChargeExpandedView']
              }"></span>
        </div>
      </div>
      <div class="p-0 col-3 d-flex justify-content-end">
        <div class="activity-description-bold">
          {{ operationCurrency }}
          {{ paymentData.ServiceCharge | currencyDecimalFormatter }}
        </div>
      </div>
    </div>
    @if (paymentData['serviceChargeExpandedView']) {
      @for (serviceItem of paymentData?.ServiceCharges; track serviceItem) {
        <div
          class="d-flex flex-row flex-wrap justify-content-between ps-5 tax-list">
          <div class="p-0 col-9">
            <div class="activity-description-bold">
              @if (serviceItem.IsPercentage) {
                <span>{{ serviceItem.ChargeName }} &#64; {{ serviceItem.ChargeValue }}%
                </span>
              }
              @if (!serviceItem.IsPercentage) {
                <span>{{ serviceItem.ChargeName }}
                </span>
              }
            </div>
          </div>
          <div class="p-0 col-3 d-flex justify-content-end">
            <div class="activity-description-bold">
              {{ operationCurrency }}
              {{ serviceItem.Amount | currencyDecimalFormatter }}
            </div>
          </div>
          @for (taxItem of serviceItem.Taxes; track taxItem) {
            <div class="d-flex flex-row justify-content-between p-0 ps-5 tax-list col-lg-12 col-md-12"
              >
              <div class="p-0 col-9">
                <div class="activity-description-bold">
                  @if (taxItem.IsPercentage) {
                    <span>{{ taxItem.ChargeName }} &#64; {{ taxItem.ChargeValue }}%
                    </span>
                  }
                  @if (!taxItem.IsPercentage) {
                    <span>{{ taxItem.ChargeName }}
                    </span>
                  }
                </div>
              </div>
              <div class="p-0 col-3 d-flex justify-content-end">
                <div class="activity-description-bold">
                  {{ operationCurrency }}
                  {{ taxItem.Amount | currencyDecimalFormatter }}
                </div>
              </div>
            </div>
          }
        </div>
      }
    }
  </ng-template>
  @if (false) {
    <div class="p-5 order-summary-empty-data activity-description-bold text-center">
      {{ "noGuestsSelected" | translate }}
    </div>
  }
  <div class="pe-4 ps-4">
    <div class="my-4 py-3 order-summary-total-price"></div>
    @if (paymentData) {
      @if (paymentData.SubTotal) {
        <div class="d-flex flex-row justify-content-between">
          <div class="p-0 col-9">
            <div class="activity-description-bold">
              {{ "SubTotal" | translate }}
            </div>
          </div>
          <div class="p-0 col-3 d-flex justify-content-end">
            <div class="activity-description-bold">
              {{ operationCurrency }}
              {{ paymentData.SubTotal | currencyDecimalFormatter }}
            </div>
          </div>
        </div>
      }
    }
    <!-- Total tax and Service Charge Amount -->
    @if (
      paymentData && paymentData?.ServiceCharge > 0 && !taxTypeForBooking
      ) {
      <span>
        <ng-container class="py-1 price-table-data-cell d-flex flex-row" *ngTemplateOutlet="
            serviceChargeInfo;
            context: { $implicit: paymentData }
          ">
        </ng-container>
      </span>
    }
    @if (paymentData && paymentData?.Tax > 0 && !taxTypeForBooking) {
      <span>
        <ng-container class="py-1 price-table-data-cell d-flex flex-row"
          *ngTemplateOutlet="vatInfo; context: { $implicit: paymentData }">
        </ng-container>
      </span>
    }
    @if (paymentData?.TaxOnServiceChargeAmount > 0) {
      <div class="d-flex flex-row justify-content-between">
        <div class="p-0 col-9">
          <div class="activity-description-bold">
            {{ "taxOnserviceCharge" | translate }}
          </div>
        </div>
        <div class="p-0 col-3 d-flex justify-content-end">
          <div class="activity-description-bold">
            {{ operationCurrency }}
            {{paymentData.TaxOnServiceChargeAmount | currencyDecimalFormatter}}
          </div>
        </div>
      </div>
    }
    <!-- <ng-container @if (paymentData && paymentData?.SubTotal > 0) {
    <div (click)="showTaxDetails = !showTaxDetails" class="d-flex flex-row justify-content-between ps-3 pe-3 cursor">
      <div class="p-0 col-9">
        <div class="activity-description-bold">{{ 'Tax' | translate}}
        </div>
      </div>
      <div class="p-0 col-3 d-flex justify-content-end">
        <div class="activity-description-bold">{{operationCurrency}} {{ paymentData.Tax | currencyDecimalFormatter}}
        </div>
      </div>
    </div>
    <ng-container @if (showTaxDetails) {
      <div class="d-flex flex-row justify-content-between ps-3 pe-3 tax-list"
        @for (taxItem of paymentData.Taxes | filterTaxType : taxType.Tax; track taxItem) {
        <div class="p-0 col-9">
          <div class="activity-description-bold"> <span @if (taxItem.IsPercentage) {>{{taxItem.ChargeName}} @
          {{taxItem.ChargeValue}}% </span>
          <span @if (!taxItem.IsPercentage) {>{{taxItem.ChargeName}} </span>
        </div>
      </div>
      <div class="p-0 col-3 d-flex justify-content-end">
        <div class="activity-description-bold">{{operationCurrency}} {{taxItem.Amount | currencyDecimalFormatter}}
        </div>
      </div>
    </div>
  </ng-container> }
</ng-container> } -->
@if (paymentData?.TotalDeposit && paymentData?.TotalDeposit > 0) {
  <div class="d-flex flex-row justify-content-between ps-3  ">
    <div class="p-0 col-9">
      <div class="activity-description-bold">{{'Deposit Total' | translate}}
      </div>
    </div>
    <div class="p-0 col-3 d-flex justify-content-end">
      <div class="activity-description-bold">{{operationCurrency}} {{ paymentData?.TotalDeposit |
        currencyDecimalFormatter}}
      </div>
    </div>
  </div>
}
@if (taxTypeForBooking && paymentData?.ServiceCharge > 0) {
  <div class="d-flex flex-row justify-content-between">
    <div class="p-0 col-9">
      <div class="activity-description-bold">
        {{ "serviceCharges" | translate }}
      </div>
    </div>
    <div class="p-0 col-3 d-flex justify-content-end">
      <div class="activity-description-bold">
        {{ operationCurrency }}
        {{ paymentData?.ServiceCharge | currencyDecimalFormatter }}
      </div>
    </div>
  </div>
}
</div>
@if (TotalAmount) {
  <div class="py-4 m-2 px-3 order-summary-grand-total d-flex flex-row justify-content-between"
      [class.highlightSection]="
        showCardOnFileInformation && TotalAmount != PayableAmount
      ">
    <div class="p-0 col-6">
      <div class="d-flex align-items-center activity-title text-uppercase">
        {{ "grandTotal" | translate
        }}@if (false) {
        <mat-icon matTooltip="{{ 'inclusiveOfAllTaxes' | translate }}" matTooltipPosition="above"
          class="ms-3 d-flex align-items-center list-info-icon cursor">
          info
        </mat-icon>
      }
    </div>
  </div>
  <div class="p-0 col-6 d-flex justify-content-end">
    <div class="activity-title">
      {{ operationCurrency }}
      {{ (TotalAmount ? TotalAmount.valueOf() : 0) | currencyDecimalFormatter }}
    </div>
  </div>
</div>
}
@if (showCardOnFileInformation && TotalAmount != PayableAmount) {
  <div
    class="py-4 m-2 px-3 order-summary-grand-total d-flex flex-row justify-content-between">
    <div class="p-0 col-6">
      <div class="d-flex align-items-center activity-title text-uppercase">
        {{ "AmountPayable" | translate
        }}@if (false) {
        <mat-icon matTooltip="{{ 'inclusiveOfAllTaxes' | translate }}" matTooltipPosition="above"
          class="ms-3 d-flex align-items-center list-info-icon cursor">
          info
        </mat-icon>
      }
    </div>
  </div>
  <div class="p-0 col-6 d-flex justify-content-end">
    <div class="activity-title">
      {{ operationCurrency }}
      {{ PayableAmount | currencyDecimalFormatter }}
    </div>
  </div>
</div>
}
@if (isEdit && balanceAmount > 0) {
  <div class="px-3 m-2 d-flex flex-row justify-content-between">
    <div class="p-0 col-9">
      <div class="activity-description-bold">
        {{ "amountPaid" | translate }}
      </div>
    </div>
    <div class="p-0 col-3 d-flex justify-content-end">
      <div class="activity-description-bold">
        {{ operationCurrency
        }}{{
        (TotalAmount
        ? TotalAmount.valueOf() -
        (!refundAmount ? balanceAmount.valueOf() : 0)
        : 0
        ) | currencyDecimalFormatter
        }}
      </div>
    </div>
  </div>
}
@if (isEdit && balanceAmount > 0) {
  <div class="px-3 m-2 d-flex flex-row justify-content-between">
    <div class="p-0 col-9">
      <div class="activity-description-bolder">
        {{
        (!refundAmount ? "balancePendingAmount" : "refundAmount")
        | translate
        }}
      </div>
    </div>
    <div class="p-0 col-3 d-flex justify-content-end">
      <div class="activity-description-bolder">
        {{ operationCurrency
        }}{{ balanceAmount.valueOf() | currencyDecimalFormatter }}
      </div>
    </div>
  </div>
}
@if (showCardOnFileInformation) {
  <div class="auth-card-info">
    <img class="auth-card-info__logo" src="assets/images/auth_card.svg" alt="agilysys-logo" />
    <div class="auth-card-info__message">
      @if (
        !activityService.widgetSettings?.AuthorizeAndPayLaterNote?.length
        ) {
        <div>
          {{ "authCardInfoMessageInfo" | translate }}
          <b>
            {{ "authCardInfoMessageOption" | translate }}
          </b>
          {{ "authCardInfoMessageValue" | translate }}
        </div>
      }
      @if (
        activityService.widgetSettings?.AuthorizeAndPayLaterNote?.length
        ) {
        <div>
          {{ activityService.widgetSettings?.AuthorizeAndPayLaterNote }}
        </div>
      }
    </div>
  </div>
}
<div class="px-3 m-2 d-flex flex-column justify-content-between">
  @if (showIframe) {
    <div class="mt-2 d-flex flex-row justify-content-between save-to-contact">
      <mat-checkbox class="chip-control__checkbox" [(ngModel)]="saveCardToContact">{{'saveCardToPayer' |
      translate}}</mat-checkbox>
    </div>
  }
  <form #guestDetailsForm="ngForm" novalidate id="guestDetailsForm">
    <ng-container *ngTemplateOutlet="termsConditions"> </ng-container>
  </form>
</div>
@if (
  !(
  urlSafe &&
  (waiverForm ||
  activityService?.reservationAttemptInfo?.CreditCardIframeUrl ||
  activityService?.reservationAttemptInfo?.CreditCardIFrameURL ||
  financialData?.RedirectUrl)
  ) || enableSubmit
  ) {
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="d-flex flex-row justify-content-center">
      <button mat-button type="button" class="m-5 activity-buttons activity-confirm-buttons text-center"
        [disabled]="disableSubmitButton" (click)="clickToPayment()">
        <!-- {{'CLICK TO PAY' | translate}} -->
        {{ "submit" | translate }}
      </button>
    </div>
  </div>
}
@if ((
  urlSafe &&
  (waiverForm ||
  activityService?.reservationAttemptInfo?.CreditCardIframeUrl ||
  activityService?.reservationAttemptInfo?.CreditCardIFrameURL ||
  financialData?.RedirectUrl)
  )
  && activityService?.DisableCustomTermsAndConditions) {
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="d-flex flex-row justify-content-center">
      <button mat-button type="button" class="m-5 activity-buttons activity-confirm-buttons text-center" (click)="validateForm()">
        {{ "next" | translate }}
      </button>
    </div>
  </div>
}
</div>
}
<!-- large screen terms and condition view removed  -->
<!-- <ng-container>
<div class="d-block d-lg-none">
  <ng-container *ngTemplateOutlet="termsConditions">
  </ng-container>
</div>
</ng-container> -->
@if (
  urlSafe &&
  (waiverForm ||
  activityService?.reservationAttemptInfo?.CreditCardIframeUrl ||
  financialData?.RedirectUrl ||
  activityService?.reservationAttemptInfo?.CreditCardIFrameURL)
  ) {
  <div class="col-xl-4 col-lg-5 col-12 mt-3 mt-xl-0 justify-content-center"[ngClass]="{'d-flex': isValidateTerms}" [hidden]="!isValidateTerms">
    <!-- <img style="width: 100%;" src="assets/images/payment-iframe.jpg" /> -->
    <!-- @if (urlSafe && !activityService.editFromCart && (!activityService.restaurantWidgetSettings$.value.IsCartEnabled || activityService.operation != operationType.create || waiverForm)) -->
    <div class="guest-data__iframe-view position-relative">
      <iframe width="100%" height="500px" frameBorder="0" [src]="urlSafe"></iframe>
      @if (checkBoxErrorMessages || showCartLockWarning) {
        <div
          class="px-5 position-absolute activity-description-bold payment-protection d-flex flex-column justify-content-center">
          <div class="p-3 d-flex justify-content-center payment-overlay-text align-items-center text-center">
            {{ "enterNecessaryDetailsForPayment" | translate }}
          </div>
        </div>
      }
    </div>
  </div>
}
</div>
</div>

<ng-template #termsConditions>
  <div class=" d-flex flex-column">
    @for (eachTerms of customTerms; track eachTerms; let i = $index) {
      <div class="d-flex flex-nowrap align-items-center">
        <div>
          <mat-checkbox class="chip-control__checkbox" [(ngModel)]="eachTerms.labelValue" #eachTerms="ngModel"
            [disabled]="eachTerms.disabled" [checked]="eachTerms.labelValue" name="{{ eachTerms.name }}"
          (ngModelChange)="checkCustomTermsAndMessageOptionValidation()"></mat-checkbox>
        </div>
        <!-- Do not use safeHtml here: it calls bypassSecurityTrustHtml and disables Angular sanitization (stored XSS via merchant CustomTermsOfService). Plain [innerHTML] keeps Angular's sanitizer; safe <a> links still render. -->
        <div class="px-3 activity-description-bold py-2" [innerHTML]="eachTerms.labelText"></div>
      </div>
    }
    @for (eachReminder of reminderSmsEmailChecks; track eachReminder; let i = $index) {
      <div class="d-flex flex-nowrap align-items-center">
        <div>
          <mat-checkbox class="chip-control__checkbox" [(ngModel)]="eachReminder.labelValue" #eachTerms="ngModel"
            [disabled]="eachReminder.disabled" [checked]="eachReminder.labelValue" name="{{ eachReminder.name }}"
          (ngModelChange)="checkCustomTermsAndMessageOptionValidation()"></mat-checkbox>
        </div>
        <!-- Same as custom terms: avoid safeHtml/bypassSecurityTrustHtml so reminder label HTML is sanitized. -->
        <div class="px-3 activity-description-bold py-2" [innerHTML]="eachReminder.labelText"></div>
      </div>
    }
    @if (formSubmitted && checkBoxErrorMessages && !activityService.DisableCustomTermsAndConditions) {
      <span class="validation-error">
        {{ checkBoxErrorMessages }}
      </span>
    }
    @if (activityService.DisableCustomTermsAndConditions) {
      @if (validationMessageList?.length) {
        <span class="validation-info" [innerHTML]="validationMessageList[0]"></span>
      }
      @if (validationMessageList?.length > 1) {
        <ul>
          @for (validationMessage of validationMessageList | slice : 1; track validationMessage; let i = $index) {
            <li class="validation-info ms-3" [innerHTML]="validationMessage"></li>
          }
        </ul>
      }
    }
  </div>
</ng-template>